import { Button, Result } from 'antd';
import type { ExceptionStatusType } from 'antd/es/result';
import { useNavigate } from 'react-router';

import { useTitle } from '/imports/ui/hooks/useTitle';
import { RouterButton } from './button/RouterButton';

export interface NotFoundProps {
  title?: string;
  text?: string;
  status?: ExceptionStatusType;
  showBackButton?: boolean;
}

export const NotFound = ({
  title = 'Not found',
  text = 'Sorry, the page you visited does not exist.',
  status = '404',
  showBackButton = true,
}: NotFoundProps) => {
  const navigate = useNavigate();
  useTitle(title);
  return (
    <Result
      title={title}
      subTitle={text}
      extra={
        showBackButton && (
          <Button type="primary" onClick={() => navigate(-1)}>
            Go back
          </Button>
        )
      }
      status={status}
    />
  );
};

// -------------------------------------------------------------------------------------------------

export interface NotAuthorizedProps {
  text?: string;
}

export const NotAuthorized = ({
  text = 'Sorry, you are not authorized to access this page.',
}: NotAuthorizedProps) => {
  const title = 'Not authorized';
  useTitle(title, text);
  return (
    <Result
      title={title}
      subTitle={text}
      extra={
        <RouterButton to="/" type="primary">
          Go to homepage
        </RouterButton>
      }
      status="403"
    />
  );
};
